<template>
  <div class="col-auto">
    <base-input class="d-inline-block">
      <el-date-picker
        size="large"
        @change="toDateChanged"
        v-model="toDate"
        type="date"
        :clearable="false">
      </el-date-picker>
    </base-input>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: "DetailedReportPeriod",
  props: {},
  components: {
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      toDate: new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 1)
    };
  },
  computed: {
    ...mapState({}),
  },
  methods: {
    ...mapActions(['SetProfileSelectedReportToDate']),
    prepareRangeApiQuery() {
      return {
        to: new Date(this.toDate.getTime() - (this.toDate.getTimezoneOffset() * 60000))
          .toISOString()
          .split("T")[0]
      }
    },
    toDateChanged() {
      let apiQuery = this.prepareRangeApiQuery()
      this.changeUrlWithToDate();
      this.SetProfileSelectedReportToDate(apiQuery)
    },
    changeUrlWithToDate() {
      let apiQuery = this.prepareRangeApiQuery();
      const removeKey = (key, {[key]: _, ...rest}) => rest;
      let tmp = removeKey("to", this.$route.query)
      this.$router.replace({
        query: Object.assign({}, tmp, {
          to: apiQuery.to
        })
      });
    },
    parseToDate(something) {
      let toDateApiQuery = null;
      if (something.to && something.to != '') {
        let dateTo = Date.parse(something.to)
        if (!isNaN(dateTo)) {
          this.toDate = new Date(dateTo)
          toDateApiQuery = this.prepareRangeApiQuery()
        }
      }

      return toDateApiQuery
    },
  },
  mounted() {
    let toDate = null

    toDate = this.parseToDate({to: this.$route.query.to})
    if (toDate != null) {
      // Period from PATH
      this.toDate = toDate.to
      this.SetProfileSelectedReportToDate(toDate)
      return
    }

    toDate = this.prepareRangeApiQuery()
    this.SetProfileSelectedReportToDate(toDate)
    this.changeUrlWithToDate()
  },
}
</script>

<style scoped>

</style>
